import { useEffect, useRef, useState } from "react";

const SizeInput = ({ value, rowIndex, setActiveRowIndex, onChange, disabled, hasError }) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  const handleIncrease = () => {
    if (disabled) return;
    const newValue = Math.max(0, (parseFloat(value) || 0) + 0.1);
    onChange(Number(newValue.toFixed(1)));
  };

  const handleDecrease = () => {
    if (disabled) return;
    const newValue = Math.max(0, (parseFloat(value) || 0) - 0.1);
    onChange(Number(newValue.toFixed(1)));
  };

  useEffect(() => {
    const handleFocusOut = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.relatedTarget)) {
        setFocused(false);
      }
    };

    const element = inputRef.current;
    if (element) {
      element.addEventListener("focusout", handleFocusOut);
    }

    return () => {
      if (element) {
        element.removeEventListener("focusout", handleFocusOut);
      }
    };
  }, []);


  const handleFocus = () => {
    if (!disabled && setActiveRowIndex && rowIndex !== undefined) {
      setActiveRowIndex(rowIndex);
    }
    if (!disabled) {
      setFocused(true);
    }
  };

  const handleInputChange = (e) => {
    if (disabled) return;
    const val = e.target.value;
    if (val === "" || val === "-") {
      onChange(val);
    } else {
      const num = parseFloat(val);
      if (!isNaN(num) && num >= 0) {
        onChange(Number(num.toFixed(1)));
      }
    }
  };

  return (
    <div
      className={`input-container ${focused ? "focused" : ""} ${
        disabled ? "disabled" : ""
      } ${hasError ? "error" : ""}`}
      ref={inputRef}
    >
      <input
        type="number"
        placeholder="Enter Value"
        value={value ?? ""}
        step="0.1"
        min="0"
        max="80"
        disabled={disabled}
        onFocus={handleFocus}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === "Tab") {

            setFocused(false);
          }
        }}
      />

      {focused && !disabled && (
        <div className="button-container">
          <button
            type="button"
            className="decrease"
            onClick={handleDecrease}
            onMouseDown={(e) => e.preventDefault()} 
            tabIndex="-1" 
          />
          <button
            type="button"
            className="increase"
            onClick={handleIncrease}
            onMouseDown={(e) => e.preventDefault()}
            tabIndex="-1"
          />
        </div>
      )}
    </div>
  );
};

export default SizeInput;